import { createFileRoute } from "@tanstack/react-router";

import { beforeLoadAuthenticated } from "../../shared/lib/before-load";

export const Route = createFileRoute("/_layout-main")({
  beforeLoad: beforeLoadAuthenticated,
});
